var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "label",
    { staticClass: "switch-label" },
    [
      _c("div", { staticClass: "switch", style: { width: _vm.width + "px" } }, [
        _c("input", {
          attrs: { type: "checkbox" },
          domProps: { checked: _vm.state.innerValue },
          on: {
            change: function($event) {
              return _vm.toggle($event)
            }
          }
        }),
        _c("span", { staticClass: "slider round" })
      ]),
      _vm.labelText
        ? _c(
            "Box",
            { staticClass: "switch-label-text", attrs: { marginLeft: 2 } },
            [
              _c(
                "layoutText",
                {
                  staticClass: "switch-text",
                  attrs: { fontSize: 1, color: "#999" }
                },
                [_vm._v(_vm._s(_vm.labelText))]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }